const ClazzShareUserKey = 'clazz-share-user'
const ClazzShareIdKey = 'clazz-share-id'

export function getClazzShareUser () {
  return sessionStorage.getItem(ClazzShareUserKey)
}

export function setClazzShareUser (userId) {
  return sessionStorage.setItem(ClazzShareUserKey, userId)
}

export function getClazzShareId () {
  return sessionStorage.getItem(ClazzShareIdKey)
}

export function setClazzShareId (clazzId) {
  return sessionStorage.setItem(ClazzShareIdKey, clazzId)
}
